import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgReduxModule } from 'ng2-redux';
import { DrawTreeModule } from 'app/+admin/+profiles/drawTree/draw-tree.module';
import { JcropModule } from 'app/shared/forms/jcrop/jcrop.module';
import { NgZorroAntdModule, NzSwitchModule } from 'ng-zorro-antd';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionModule } from 'ngx-bootstrap';
import { OfflineSalesActionsComponent } from './offline-sales-actions.component';

@NgModule({
  declarations: [
    OfflineSalesActionsComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    NgReduxModule.forRoot(),
    AccordionModule.forRoot(),
    DrawTreeModule,
    JcropModule,
    NgZorroAntdModule.forRoot(),
    NzSwitchModule,
    ReactiveFormsModule,
    DragDropModule,
    NgSelectModule,
  ],
  entryComponents: [OfflineSalesActionsComponent],
})
export class OfflineSalesActionsModule { }
